import { render, staticRenderFns } from "./SolicitacaoCriada.vue?vue&type=template&id=327a30ac"
import script from "./SolicitacaoCriada.vue?vue&type=script&lang=js"
export * from "./SolicitacaoCriada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports